import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

Sentry.init({
  dsn: import.meta.env.MODE === 'production'
    ? 'https://579d1fdeebd65fa41f72a9ac8e186223@o4510863423897600.ingest.us.sentry.io/4510874666795008'
    : undefined,
  sendDefaultPii: true,
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
